import { WebServiceClient } from '../WebServiceClient'

export default class GeoAuth extends WebServiceClient {
  static get URL (): string { return 'https://data.geo.dk/token' }

  constructor (params: {username: string, password: string, role: string} | {permaToken: string}) {
    super(GeoAuth.URL, params)
  }

  async fetchToken (): Promise<string> {
    const response: Response = await fetch(this.url())
    if (!response.ok) {
      throw new Error('Got invalid HTTP response.')
    }

    const tokenData = await response.text()
    if (tokenData.length < 3) {
      throw new Error('Token of invalid length received.')
    }

    return tokenData.slice(1,-1);
  }
}
